import './PageTabBar.scss'
import React from 'react'

export default ({ children }) => (
  <div className="page-tabbar">
    { children }
  </div>
)
